import { render, staticRenderFns } from "./ProductMoneyRd.vue?vue&type=template&id=0cb07875&scoped=true&"
import script from "./ProductMoneyRd.vue?vue&type=script&lang=js&"
export * from "./ProductMoneyRd.vue?vue&type=script&lang=js&"
import style0 from "./ProductMoneyRd.vue?vue&type=style&index=0&id=0cb07875&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb07875",
  null
  
)

export default component.exports